/**
 * Delivery tag (design "Delivery tag"): 20 px high, 1 px border, radius 6,
 * 11/600, a 14 px channel glyph square then the label. Copy comes from
 * deliveryModel so it is tested without rendering.
 */
import React from 'react';
import type { DeliveryTagView, DeliveryTone, Glyph } from '../deliveryModel';

const FG: Record<DeliveryTone, string> = {
  default: 'var(--text2)',
  danger: 'var(--negFg)',
  brand: 'var(--brand)',
};

export function ChannelGlyph({ glyph, size = 14, title }: { glyph: Glyph; size?: number; title?: string }) {
  return (
    <span
      aria-hidden={title ? undefined : true}
      title={title}
      className="grid shrink-0 place-items-center font-bold text-white"
      style={{ width: size, height: size, borderRadius: size >= 20 ? 6 : 4, background: glyph.bg, fontSize: Math.round(size * 0.6) }}
    >
      {glyph.letter}
    </span>
  );
}

export default function DeliveryTag({ tag }: { tag: DeliveryTagView }) {
  return (
    <span
      className="inline-flex h-5 items-center gap-[5px] whitespace-nowrap rounded-md border border-borderc pl-[3px] pr-[7px] text-[11px] font-semibold"
      style={{ color: FG[tag.tone] }}
    >
      <ChannelGlyph glyph={tag.glyph} />
      {tag.label}
    </span>
  );
}

export function DeliveryTags({ tags, className = '' }: { tags: DeliveryTagView[]; className?: string }) {
  if (!tags.length) return null;
  return (
    <span className={`flex flex-wrap items-center gap-1.5 ${className}`}>
      {tags.map((t) => <DeliveryTag key={t.key} tag={t} />)}
    </span>
  );
}
